import { render } from "./Bank.vue?vue&type=template&id=6946c54e&scoped=true"
import script from "./Bank.vue?vue&type=script&lang=js"
export * from "./Bank.vue?vue&type=script&lang=js"

import "./Bank.vue?vue&type=style&index=0&id=6946c54e&scoped=true&lang=scss"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6946c54e"]])

export default __exports__